// extracted by mini-css-extract-plugin
export default {"menu":"bb","button":"cb","buttonIcon":"db","list":"eb","buttonActive":"fb","listWrapper":"gb"};